import React from 'react';
import {
  Card,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import CardHeader from '@material-ui/core/CardHeader';
import { makeStyles } from '@material-ui/core/styles';
import {
  useTranslate,
  EditButton,
  DeleteButton
} from 'react-admin';
import PostFilter from '../../Components/PostFilter';

const useStyles = makeStyles({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0.5rem 0',
    borderRadius : '16px',
    marginBottom: '15px',
    boxShadow: '1px 3px 7px #3b824b'
  },
  cardTitleContent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
  },
  cardContentRow: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      margin: '0.5rem 0',
  },
  cardHeader : {
    backgroundColor: '#525b59',
    paddingBottom: '10px',
    paddingTop: '10px',
    color: 'white'
  }
});

const MobileUsuarioList = (propsDataGrid) => {
  const { ids, data, checkPermiso } = propsDataGrid;
  const classes = useStyles();
  const translate = useTranslate();
  return (
    <div style={{ margin: '0.5em' }}>
      <div style={{marginLeft:'15%'}}>
        <PostFilter/>
      </div>
      {ids && ids.map(id => (
            <Card key={id} className={classes.card}>
               <CardHeader
                        className={classes.cardHeader }
                        title={
                          <div className={classes.cardTitleContent} alignItems="center">
                                <span style={{ fontSize: 'large' }}>
                                { translate("traducciones.campos.usuario") } : { data[id].Nombre } 
                                </span>
                            </div>
                        }
                    />
                <div style= { { padding: '16px', paddingTop: '5px'} }>
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px', fontWeight: 'bold'}}>{ translate("traducciones.campos.rol") }:</span>  
                        { data[id].RolNombre } 
                      </span>
                  </div> 
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px', fontWeight: 'bold'}}>{ translate("traducciones.campos.estadoUsuario") }:</span>  
                        { data[id].EstadoNombre } 
                      </span>
                  </div>
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px', fontWeight: 'bold'}}>{ translate("traducciones.campos.estadoPassword") }:</span>  
                        { data[id].EstadoPasswordNombre } 
                      </span>
                  </div>
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px', fontWeight: 'bold'}}>{ translate("traducciones.campos.vigenciaPassword") }:</span>  
                        { data[id].VigenciaDias } 
                      </span>
                  </div>
                  <div style= { { marginBottom: '5px '}}>
                      <span>
                        <span  style= {{ marginRight: '5px', fontWeight: 'bold'}}>{ translate("traducciones.campos.email") }:</span>  
                        <div>{ data[id].Email } </div> 
                      </span>
                  </div>   
                  <div  align="right" >
                  { checkPermiso('EditarUsuarios') && <EditButton record={ data[id] } label="" className="actionButton" /> }
                  { checkPermiso('EliminarUsuarios') && <DeleteButton record = { data[id] } label="" className="actionButton" undoable={false} confirmTitle={translate('traducciones.modal.eliminarUsuario')} confirmContent={translate('traducciones.modal.eliminarUsuarioConfirm')}></DeleteButton> }
                  </div>             
                </div>
            </Card>
          ))
          }
    </div>
  );
};


MobileUsuarioList.propTypes = {
  source: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};


export default MobileUsuarioList;